// extracted by mini-css-extract-plugin
export default {"figure":"Figure_figure__XU3p6","figureEatable":"Figure_figureEatable__Rr6Vh"};